<template>
  <el-row id="roadSideCarInfoView">
    <el-dialog :title="dialogTitle"
               width="55%"
               top="7vh"
               v-loading="true"
               :visible.sync="dialogFormVisible"
               v-dialogDrag>
      <el-form ref="form"
               :model="form"
               label-width="110px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="最后操作时间">
              <el-input v-model="form.fOpLastTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="最后操作用户">
              <el-input v-model="form.fOpUserName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车牌来源">
              <el-input v-model="form.fConfidence"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="车牌号码">
              <el-input v-model="form.fPlateCode"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车牌颜色">
              <el-input v-model="form.fPlateColor"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车辆类型">
              <el-input v-model="form.fCarTypeName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="月卡用户">
              <el-input v-model="form.CustName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="月卡类型">
              <el-input v-model="form.fCardTypeName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="月卡分组">
              <el-input v-model="form.fCardGroupName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="进场时间">
              <el-input v-model="form.fInTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="进场方式">
              <el-input v-model="form.fInStatus"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="车位编号">
              <el-input v-model="form.fCarNumber"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="进场识别车牌">
              <el-input v-model="form.fInPlate"
                        :class="{ isRed: form.fInPlate!=form.fPlateCode }"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="进场备注">
              <el-input v-model="form.fInRemark"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="进场操作员">
              <el-input v-model="form.fInUserName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="出场时间">
              <el-input v-model="form.fOutTime"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="8">
            <el-form-item label="出场通道">
              <el-input v-model="form.fOutParkChnlName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="出场方式">
              <el-input v-model="form.fOutStatus"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="出场识别车牌">
              <el-input v-model="form.fOutPlate"
                        :class="{ isRed: form.fOutPlate!=form.fPlateCode }"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出场备注">
              <el-input v-model="form.fOutRemark"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="出场操作员">
              <el-input v-model="form.fOutUserName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="停车时长">
              <el-input v-model="form.fTotalSecs"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="免费时长">
              <el-input v-model="form.fFreeSecs"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="计费时长">
              <el-input v-model="form.fPaySecs"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- <el-col :span="8">
            <el-form-item label="计费费率">
              <el-input v-model="form.fRateGroupName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="8">
            <el-form-item label="普通日费率">
              <el-input v-model="form.fCommRateName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="节假日费率">
              <el-input v-model="form.fHolidayRateName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="计费金额">
              <el-input v-model="form.fCalcAmt"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="支付金额">
              <el-input v-model="form.fPayAmt"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="交班时间">
              <el-input v-model="form.fExgDate"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="交班用户">
              <el-input v-model="form.fExgUserName"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-tabs v-model="activeName"
               type="card">
        <el-tab-pane label="进场图片"
                     name="first">
          <el-row>
            <el-col :span="24"
                    class="tab_img">
              <div class="block">
                <span class="demonstration"
                      style="color:red">{{form.fInExpiredTip}}</span>
                <!-- <img src="../assets/images/zoom.png"
                     alt="详情"
                     title="详情"
                     class="img_zoom"
                     :style="{display:in_display}"
                     @click="show_dev_in" /> -->
                <el-image :src="form.fInPic">
                  <div slot="error"
                       class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <el-image :src="form.fInPlatePic">
                  <div slot="error"
                       class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </el-col>
            <!-- <el-col :span="12"
                    class="tab_img">
              <div class="block">
                <span class="demonstration">出场图片</span>
                <img src="../assets/images/zoom.png"
                     alt="详情"
                     title="详情"
                     class="img_zoom"
                     :style="{display:out_display}"
                     @click="show_dev_out" />
                <el-image :src="form.fOutPic"
                          @load="out_load">
                  <div slot="error"
                       class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </el-col> -->
          </el-row>
        </el-tab-pane>
        <el-tab-pane :label="payTitle"
                     name="second">
          <el-row>
            <el-col :span="24">
              <el-table :data="payData"
                        v-loading="loading"
                        border
                        stripe
                        style="width: 100%">
                <el-table-column prop="fRowNumber"
                                 width="50"
                                 label="序号">
                </el-table-column>
                <el-table-column prop="fPayTime"
                                 width="160"
                                 label="时间">
                </el-table-column>
                <el-table-column prop="fPayment"
                                 width="200"
                                 label="支付方式">
                </el-table-column>
                <el-table-column prop="fPayCount"
                                 align="right"
                                 width="120"
                                 label="支付数量">
                </el-table-column>
                <el-table-column prop="fPayAmount"
                                 align="right"
                                 width="120"
                                 label="支付金额">
                </el-table-column>
                <el-table-column prop="fRemark"
                                 label="备注">
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane :label="arrTitle"
                     name="third">
          <el-row>
            <el-col :span="24">
              <el-table :data="arrData"
                        border
                        stripe
                        style="width: 100%">
                <el-table-column width="50"
                                 type="index"
                                 :index="indexMethod"
                                 label="序号">
                </el-table-column>
                <el-table-column prop="fParkName"
                                 label="场库">
                </el-table-column>
                <el-table-column prop="fPlateCode"
                                 label="车牌">
                </el-table-column>
                <el-table-column prop="fInTime"
                                 width="160"
                                 label="进场时间">
                </el-table-column>
                <el-table-column prop="fOutTime"
                                 width="160"
                                 label="出场时间">
                </el-table-column>
                <el-table-column prop="fCalcAmt"
                                 align="right"
                                 label="欠费金额">
                </el-table-column>
                <el-table-column prop="fDevAccNo"
                                 label="录入员工">
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
          <el-row class="pagination">
            <el-col :span="24">
              <span class="demonstration"></span>
              <el-pagination @current-change="handleCurrentChange"
                             @size-change="handleSizeChange"
                             :current-page="pageSearch.pageIndex"
                             :page-size="pageSearch.pageSize"
                             :page-sizes="[10, 20, 50, 100]"
                             background
                             layout="total, sizes, prev, pager, next, jumper"
                             :total="pageCount"
                             v-if="pageCount>0">
              </el-pagination>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </el-row>
</template>
<script>
import { report as api } from '../api/roadSideReport'
export default {
  name: 'roadSideCarInfoView',
  data () {
    return {
      payData: [],
      arrData: [],
      is_out: false,
      in_display: 'none',
      out_display: 'none',
      dialogTitle: '',
      loading: false,
      dialog_dev_Title: '',
      dialogFormVisible: false,
      dialogdevFormVisible: false,
      activeName: 'first',
      payTitle: '支付明细',
      arrTitle: '欠费记录',
      pageCount: 0,
      pageSearch: {
        isView: 1,
        fCustID: '',
        fBusID: '',
        searchKeyWord: '',
        pageIndex: 0,
        pageSize: 10
      },
      form: {
        fCarNumber: '',
        fCustName: '',
        fParkName: '',
        fOpLastTime: '',
        fOpUserName: '',
        fConfidence: '',
        fPlateCode: '',
        fPlateColor: '',
        fCarTypeName: '',
        fInTime: '',
        fInChnlName: '',
        fInStatus: '',
        fOutTime: '',
        fOutChnlName: '',
        fOutStatus: '',
        fTotalSecs: '',
        fFreeSecs: '',
        fPaySecs: '',
        fRateGroupName: '',
        fCalcAmt: '',
        fPayAmt: '',
        fExgDate: '',
        fExgUserName: '',
        fInPlate: '',
        fOutPlate: '',
        fInRemark: '',
        fOutRemark: '',
        CustName: '',
        fCardGroupName: '',
        fCardTypeName: '',
        fInPic: '',
        fOutPic: '',
        fInPlatePic: '',
        fOutPlatePic: '',
        fInExpiredTip: '',
        fOutExpiredTip: ''
      }
    }
  },
  props: {
    type: Number,
    isNeedCustIdSearch: Boolean
  },
  methods: {
    in_load (e) {
      this.in_display = 'block'
    },
    out_load (e) {
      this.out_display = 'block'
    },
    handleInfo (row) {
      this.in_display = 'none'
      this.out_display = 'none'
      this.payTitle = '支付明细'
      this.arrTitle = '欠费记录'
      this.activeName = 'first'
      this.dialogTitle = '查看车辆信息'
      this.form = { fInPic: '', fOutPic: '', fInPlatePic: '', fOutPlatePic: '' }
      this.dialogFormVisible = true
      var params = {}
      if (row.fBigRowID && !this.isNeedCustIdSearch) {
        params = { id: row.fBigRowID, type: this.type }
      } else {
        params = { id: 0, fCustID: row.fCustID, fBusID: row.fBusID, type: this.type }
      }
      this.pageSearch.fCustID = row.fCustID
      this.pageSearch.searchKeyWord = row.fPlateCode
      if (this.type === 4) {
        params.fBusID = row.fBusID
        this.pageSearch.fBusID = row.fBusID
      }
      api.carBusInfo(params).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            var rowData = data.Data || {}
            if ((rowData.fInPic || '').length <= 0) {
              rowData.fInPic = ' '
            }
            if ((rowData.fOutPic || '').length <= 0) {
              rowData.fOutPic = ' '
            }
            rowData.fInParkChnlName = rowData.fInChnlName
            if ((rowData.fInParkName || '').trim().length > 0) {
              rowData.fInParkChnlName += '(' + rowData.fInParkName + ')'
            }
            rowData.fOutParkChnlName = rowData.fOutChnlName
            if ((rowData.fOutParkName || '').trim().length > 0) {
              rowData.fOutParkChnlName += '(' + rowData.fOutParkName + ')'
            }
            this.form = rowData
            if ((this.form.fCustName || '').length > 0) {
              var strTitle = this.form.fCustName
              if ((this.form.fInParkName || '').length > 0) {
                strTitle += '-' + this.form.fInParkName
              } else if ((this.form.fOutParkName || '').length > 0) {
                strTitle += '-' + this.form.fOutParkName
              }
              this.dialogTitle = '【' + strTitle + '】查看车辆信息'
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
      api.carBusPayInfo({ fCustID: row.fCustID, fBusID: row.fBusID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.payData = data.Data || []
            if (this.payData.length > 0) {
              this.payTitle = '支付明细【' + this.payData.length + '】'
            }
          } else {
            this.$message.error('提示：加载支付明细列表失败')
          }
        }
      })
      this.page_list()
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    page_list (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      api.arrMainList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageCount = data.Data.count
            this.arrData = data.Data.data || []
            if (this.pageCount > 0) {
              this.arrTitle = '欠费记录【' + this.pageCount + '】'
            }
          } else {
            this.$message.error('提示：加载欠费记录列表失败')
          }
        }
      })
    }
  },
  created () {
  },
  mounted () {
  }
}
</script>
<style>
#roadSideCarInfoView .tab_img .block {
  text-align: center;
  position: relative;
  margin-top: 10px;
}
#roadSideCarInfoView .el-image__inner {
  vertical-align: middle;
}
#roadSideCarInfoView .tab_img .demonstration {
  display: block;
  text-align: center;
  margin-bottom: 5px;
  margin-top: 5px;
}
#roadSideCarInfoView .tab_img .el-image {
  width: 400px;
  height: 250px;
  display: inline-block;
}
#roadSideCarInfoView .tab_img .image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
}
#roadSideCarInfoView .car_img .el-image__inner {
  width: 200px;
  height: 80px;
}
#roadSideCarInfoView .car_img .image-slot {
  width: 200px;
  height: 80px;
  background: #f5f7fa;
  color: #909399;
  font-size: 30px;
  display: inline-block;
  line-height: 80px;
  text-align: center;
}
#roadSideCarInfoView .fInRemark_item .el-form-item__content {
  height: auto;
}
#roadSideCarInfoView .el-dialog {
  min-width: 840px;
}
#roadSideCarInfoView .isRed .el-input__inner {
  color: red !important;
}
</style>
<style scoped>
.fplate_info {
  overflow: hidden;
  width: 350px;
  margin: 0px auto;
}
.car_img .img {
  max-width: 100%;
  max-height: 100%;
}
.fplate_span {
  font-size: 20px;
}
.img_zoom {
  display: none;
  position: absolute;
  right: calc((100% - 400px) / 2);
  cursor: pointer;
  background: #d1192b;
  z-index: 100;
  /* opacity: 0.5;
  filter: alpha(opacity=50); */
}
.el-form-item {
  margin-bottom: 5px;
}
.el-pagination {
  padding-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/roadSideCarInfoView.vue